<template>
  <v-container
    v-if="shiftModel"
    class="mt-4">
    <v-row id="wrapper_row">
      <v-col cols="8">
        <v-data-table
          class="border-table"
          density="compact"
          :headers="headers"
          hide-no-data
          item-value="id"
          :items="shifts">
          <template #item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.mandatory_charges_percentage_shift }}</td>
              <td>{{ item.voluntary_charges_percentage_shift }}</td>
              <td>
                {{ item.non_wage_labour_cost_surcharge_percentage_shift }}
              </td>
              <td class="text-no-wrap">
                <EmbeddedTableActionButtons
                  data-cy="shift"
                  :clone-action="() => cloneAction(item.id)"
                  :delete-action="() => deleteAction(item.id)"
                  :edit-action="() => editAction(item.id)" />
              </td>
            </tr>
          </template>

          <!-- Removed pagination, create button -->
          <template #[`header.actions`]>
            <div class="pb-4 text-center">
              <v-btn
                class="mx-1 px-0 mt-4"
                color="#ECE6F0"
                elevated="26"
                max-width="40"
                min-width="40"
                rounded="lg"
                data-cy="add-element-shift"
                @click="addAction">
                <v-icon
                  color=" #0F6DAC"
                  size="x-large">
                  mdi-plus
                </v-icon>
              </v-btn>

              <v-dialog
                v-model="popupForm"
                opacity="0.6"
                scrollable
                width="80%">
                <ShiftPopupFormView
                  v-if="shiftId"
                  :id="shiftId"
                  :close-dialog="
                    () => {
                      popupForm = false;
                      shiftId = null;
                    }
                  " />
              </v-dialog>
            </div>
          </template>
        </v-data-table>
      </v-col>
      <v-col
        id="shifts_notes_col"
        cols="4">
        <NotesEditor
          :id="shiftModelId"
          field="shifts_notes_shiftModel"
          :placeholder="
            $t('entities.shiftModel.fields.shifts_notes_shiftModel')
          " />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useTranslation } from "i18next-vue";
import EmbeddedTableActionButtons from "@/components/DataTable/EmbeddedTableActionButtons.vue";
import { useSpaceStore } from "@/stores/spaceStore";
import { useRouter } from "vue-router";
import NotesEditor from "@/components/Elements/NotesEditor.vue";

const spaceStore = useSpaceStore();

const { t } = useTranslation();
const shiftModel = ref(null);

const popupForm = ref(false);
const shiftId = ref(null);

const props = defineProps({
  shiftModelId: {
    type: String,
    required: true
  }
});

const shifts = computed(() => {
  return Object.entries(spaceStore.calculationElements).reduce(
    (result, [id, element]) => {
      if (
        id.endsWith("shift") &&
        spaceStore.calculationElements[props.shiftModelId].children.includes(id)
      ) {
        result.push(Object.assign({}, element, { id }));
      }
      return result;
    },
    []
  );
});

onMounted(() => {
  shiftModel.value = spaceStore.calculationElements[props.shiftModelId];
});

const headers = computed(() => [
  {
    title: t("entities.shift.fields.name"),
    align: "start",
    sortable: false,
    key: "name"
  },
  {
    title: t("entities.shift.fields.mandatory_charges_percentage_shift"),
    key: "mandatory_charges_percentage_shift",
    sortable: false
  },
  {
    title: t("entities.shift.fields.voluntary_charges_percentage_shift"),
    key: "voluntary_charges_percentage_shift",
    sortable: false
  },
  {
    title: t(
      "entities.shift.fields.non_wage_labour_cost_surcharge_percentage_shift"
    ),
    key: "non_wage_labour_cost_surcharge_percentage_shift",
    sortable: false
  },
  {
    title: "",
    key: "actions",
    sortable: false
  }
]);

const router = useRouter();

const addAction = () => {
  shiftId.value = spaceStore.createElement("shift", props.shiftModelId);
  router.push({
    name: "calculations-shift",
    params: { nodeId: shiftId.value }
  });

  // popupForm.value = true;
};

const editAction = (id) => {
  shiftId.value = id;
  router.push({
    name: "calculations-shift",
    params: { nodeId: shiftId.value }
  });

  // popupForm.value = true;
};

const cloneAction = (id) => {
  spaceStore.prepareClone(id);
  spaceStore.cloneOnServer(props.shiftModelId, false);

  // router.push({
  //   name: "calculations-shift",
  //   params: { nodeId: shiftId.value }
  // });
};

const deleteAction = (id) => {
  spaceStore.removeElement(id);
};
</script>

<style scoped>
#shifts_notes_col {
  height: 100px !important;
}

#wrapper_row {
  min-height: 170px;
}
</style>
